export default {"src":"/_next/static/media/InsuranceGroup-1_horizontal.82ca7dee.svg","height":162,"width":1066};